<template>
  <zul-modal
    :class="{
      'is-small': true,
    }"
    type="neutral"
    id="pixModal"
    ref="modal"
  >
    <fieldset v-if="isLoading">
      <p class="loading">{{$t('global.loading')}}</p>
    </fieldset>

    <fieldset class="pix-pending-wrapper" v-if="!isLoading">
      <h2 class="title">{{$t('global.payment')}}</h2>

      <div>
        <span class="pix-label">{{$t('global.buy')}}:</span>
        <span class="pix-value">{{
          (currentOrder || {}).total
            | currency("", 2, { decimalSeparator: "," })
        }}</span>
      </div>

      <p class="pix-logo">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.7317 13.44C11.9423 13.2295 12.3094 13.2288 12.5199 13.44L15.5198 16.4397C16.0746 16.9944 16.8126 17.2999 17.5973 17.2999H17.9587L14.1484 21.1101C12.9619 22.2966 11.0381 22.2966 9.85151 21.1101L6.05229 17.3108H6.64342C7.42813 17.3108 8.1661 17.0053 8.721 16.4507L11.7317 13.44ZM5.20156 7.53994C5.25 7.55819 5.30137 7.57118 5.35621 7.57118H6.64344C7.1847 7.57118 7.7144 7.79064 8.09688 8.17331L11.1079 11.1843C11.3886 11.4648 11.7572 11.6053 12.126 11.6053C12.4946 11.6053 12.8634 11.4648 13.144 11.1841L16.1438 8.18422C16.5262 7.80155 17.056 7.58209 17.5973 7.58209H18.6441C18.702 7.58209 18.7569 7.56939 18.8076 7.54907L21.1101 9.85158C22.2966 11.0381 22.2966 12.9619 21.1101 14.1485L18.8077 16.4509C18.7569 16.4305 18.7021 16.4179 18.6441 16.4179H17.5973C17.056 16.4179 16.5262 16.1985 16.1438 15.8157L13.144 12.8162C12.6004 12.272 11.6518 12.2722 11.1076 12.816L8.09688 15.8267C7.7144 16.2094 7.1847 16.4288 6.64344 16.4288H5.35621C5.30137 16.4288 5.24991 16.4418 5.20147 16.4601L2.88993 14.1485C1.70336 12.9619 1.70336 11.0381 2.88993 9.85158L5.20156 7.53994ZM9.85153 2.88993C11.0381 1.70336 12.9619 1.70336 14.1485 2.88993L17.9586 6.70008H17.5973C16.8126 6.70008 16.0746 7.00562 15.5197 7.56024L12.52 10.5603C12.3026 10.7783 11.9485 10.7774 11.7317 10.5606L8.72093 7.54933C8.16611 6.99471 7.42815 6.68908 6.64344 6.68908H6.05241L9.85153 2.88993Z"
            fill="currentColor"
          />
        </svg>
        <span>Pix</span>
      </p>

      <div class="pix-qrcode" v-if="order && currentOrder.remainingTime !== 0">
        <QrcodeVue
          :value="currentOrder && currentOrder.qrCode"
          size="120"
        ></QrcodeVue>
      </div>

      <button
        class="button is-primary is-large copy-pix"
        @click="copyPixNumber"
        v-if="(currentOrder || {}).remainingTime !== 0"
      >
        {{$t('global.pix.instruction')}}
      </button>

      <p class="warning-text" v-if="(currentOrder || {}).remainingTime === 0">
        <svg
          width="71"
          height="72"
          viewBox="0 0 71 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M35.5 70.1666C54.3697 70.1666 69.6666 54.8697 69.6666 35.9999C69.6666 17.1302 54.3697 1.83325 35.5 1.83325C16.6303 1.83325 1.33331 17.1302 1.33331 35.9999C1.33331 54.8697 16.6303 70.1666 35.5 70.1666Z"
            stroke="#FF453A"
            stroke-width="2"
            stroke-linecap="square"
            stroke-linejoin="round"
          />
          <path
            d="M47.3501 25.5628L48.0572 24.8557L46.6429 23.4415L45.9358 24.1486L47.3501 25.5628ZM23.6487 46.4358L22.9416 47.1429L24.3558 48.5571L25.0629 47.85L23.6487 46.4358ZM25.0629 24.1486L24.3558 23.4415L22.9416 24.8557L23.6487 25.5628L25.0629 24.1486ZM45.9358 47.85L46.6429 48.5571L48.0572 47.1429L47.3501 46.4358L45.9358 47.85ZM45.9358 24.1486L23.6487 46.4358L25.0629 47.85L47.3501 25.5628L45.9358 24.1486ZM23.6487 25.5628L45.9358 47.85L47.3501 46.4358L25.0629 24.1486L23.6487 25.5628Z"
            fill="#FF453A"
          />
        </svg>
        <br />

        <strong>{{$t('global.pix.expired.title')}}</strong><br />
        <span v-html="$t('global.pix.expired.message')"></span>
      </p>

      <input
        type="text"
        class="hidden-pix-number"
        ref="pixNumber"
        :value="currentOrder && currentOrder.qrCode"
        v-if="(currentOrder || {}).remainingTime !== 0"
      />

      <p class="countdown" v-if="(currentOrder || {}).remainingTime > 0">
        {{ timeRemaining }}
      </p>

      <button
        v-if="
          (currentOrder || {}).remainingTime !== 0 &&
          (currentOrder || {}).status === 'PENDING'
        "
        @click.prevent="cancel"
        class="button is-light is-medium cancel-order"
      >
        {{$t('global.pix.buttonCancel')}}
      </button>
    </fieldset>
  </zul-modal>
</template>
<script>
import QrcodeVue from "qrcode.vue";
import ZulButton from "./Button.vue";

export default {
  props: ["order"],
  data() {
    return {
      currentOrder: {},
      isLoading: false,
      expirationDate: null,
      timeRemaining: "00:00:00",
      timeRemainingInterval: null,
      polling: null
    };
  },
  beforeUnmount() {
    clearInterval(this.timeRemainingInterval);
    clearInterval(this.this.polling);
  },
  mounted() {
    this.$root.$on("pixModal-end", () => {
      clearInterval(this.timeRemainingInterval);
    });
  },
  watch: {
    order: {
      immediate: true,
      handler(newOrderValue) {
        this.currentOrder = newOrderValue;
      },
    },
  },
  methods: {
    update(remainingTimeParam) {
      const now = new Date();
      const totalTime = remainingTimeParam * 1000;
      this.expirationDate = new Date(now.getTime() + totalTime);

      this.updateRemainingTime();
    },
    open(updateFromServer = true) {
      this.remainingTime = "00:00:00";

      this.$refs.modal.open();

      if (updateFromServer) {
        this.isLoading = true;

        this.$http
          .get(`/order/${this.currentOrder.id}`)
          .then((response) => {
            const { data } = response;
            this.currentOrder = data;
            this.update(data.remainingTime);
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        setTimeout(() => {
          this.update(this.currentOrder.remainingTime);
        }, 1000);

        if (this.currentOrder.category == 'REGULARIZATION') {
          this.polling = setInterval(() => {
            this.REGULARIZATION.get(`/regularization/order/${this.currentOrder.id}`)
              .then((response) => {
                if(response.data.status === "FINISHED") {
                  clearInterval(this.polling);
                  this.$root.$emit('pix-approved', response.data);
                } else if(response.data.status === "PAYMENT_REJECTED") {
                  this.$root.$emit('cancel-pix-end');

                  this.$buefy.toast.open({
                    message: this.$t('global.pix.canceled.message'),
                    type: "is-danger",
                  });
                }
            })
          }, 2000)
        }
      }
    },
    cancel() {
      this.isLoading = true;

      if (this.currentOrder.category =='REGULARIZATION') {
        this.REGULARIZATION.delete(`/regularization/order/${this.currentOrder.id}`)
          .then(() => {
            this.$root.$emit('cancel-pix-end')
            this.$buefy.toast.open({
              message: this.$t('global.pix.canceled.message'),
              type: "is-success",
            });

            this.close();
          }).catch((error) => {
            const message =
              (((error || {}).response || {}).data || {}).message || this.$t('global.error.message');

            this.$buefy.toast.open({
              message,
              type: "is-danger",
            });
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$http
          .put(`/order/${this.currentOrder.id}/cancel`)
          .then(() => {
            this.$root.$emit(`set-pending-order`, null);
            this.$root.$emit('cancel-pix-end');
            this.$buefy.toast.open({
              message: this.$t('global.pix.canceled.message'),
              type: "is-success",
            });

            this.close();
          })
          .catch((error) => {
            const message =
              (((error || {}).response || {}).data || {}).message || this.$t('global.error.message');

            this.$buefy.toast.open({
              message,
              type: "is-danger",
            });
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    copyPixNumber() {
      this.$refs.pixNumber.select();

      const result = document.execCommand("copy");

      if (result) {
        this.$buefy.toast.open({
          message: "Pix copiado!",
          type: "is-success",
        });
      }
    },
    formatTime(number) {
      if (number < 10) {
        return "0" + number;
      }

      return number;
    },
    updateRemainingTime() {
      clearInterval(this.timeRemainingInterval);

      this.timeRemainingInterval = setInterval(() => {
        const remaining = this.expirationDate - new Date();
        const hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
        const seconds = Math.floor((remaining / 1000) % 60);
        const minutes = Math.floor((remaining / 1000 / 60) % 60);

        this.timeRemaining = [hours, minutes, seconds]
          .map((time) => this.formatTime(time))
          .join(":");

        if (seconds <= 0 && hours <= 0 && minutes <= 0) {
          this.remainingTime = "00:00:00";
          this.currentOrder.remainingTime = 0;
          clearInterval(this.timeRemainingInterval);
          return;
        }
      }, 1000);
    },
    close() {
      this.$refs.modal.close();
      clearInterval(this.timeRemainingInterval);
      clearInterval(this.polling);
    },
  },
  components: {
    ZulButton,
    QrcodeVue,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/sass/variables";

.button.is-primary {
  position: absolute;
  right: 2rem;
  top: 2.5rem;

  padding: 0.75rem 3rem 0.75rem 1rem;
  font-size: $size-6;
  height: 3rem;

  background: transparent $orderWhiteIcon no-repeat 87% center;

  @each $city, $map in $cities {
    .is-#{$city} & {
      background-color: map-get($map, "primary");
    }
  }
}

.balance-modal {
  .title {
    font-size: 1rem;
    text-transform: uppercase;
    background-size: contain;

    &.has-icon {
      padding-left: 3rem;
      background-repeat: no-repeat;
      background-position: 10px center;

      &.car {
        background-image: $carIcon;
      }
      &.motorcycle {
        background-image: $motorcycleIcon;
        background-position: 19px center;
      }
    }
  }
}

fieldset {
  border: none;
  text-align: center;

  .title {
    font-size: $size-5;
    text-transform: uppercase;
  }

  .info {
    font-size: $size-6;
    margin: 0.75rem 2rem 1.5rem;
  }

  .sub {
    opacity: 0.5;
  }

  .is-view {
    margin: 0.75rem 0 1.5rem;
  }

  .summary {
    .is-view {
      margin: 0;
    }
  }

  .warning {
    padding: 0.75rem 1.5rem 0.5rem;
    font-size: $size-7;

    .title {
      font-size: $size-6;
      text-transform: uppercase;
    }
  }

  .is-success-order {
    display: inline-block;
    margin-bottom: 2rem;
  }

  // big modal
  .is-large & {
    .warning {
      padding: 0.75rem 3rem 0.5rem;
    }
  }
}

h3.title {
  margin-top: 18px;
  margin-bottom: 10px;
}

.loading {
  background: url("../assets/loading.svg") no-repeat center 35%;
  background-size: 100px;
  text-align: center;
  padding: 7rem 0 0;
  font-size: $size-7;
  opacity: 0.5;
  margin-right: 0;
}

.pix-pending-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  .pix-label {
    font-weight: 700;
    display: inline-flex;
    margin-right: 5px;
  }

  .pix-value {
    font-weight: 700;
    display: inline-flex;
    margin-right: 5px;
    color: #09b6f3;
    font-size: 19px;
  }

  .pix-logo {
    margin-top: 15px;
    display: inline-flex;
    align-items: center;

    > svg {
      width: 40px;
      height: 40px;
    }

    > span {
      font-size: 20px;
      margin-left: 10px;
    }
  }

  > .button.is-primary.copy-pix {
    position: static !important;
    width: auto;
    padding-left: 2rem;
    padding-right: 2rem;
    background-image: none;
    margin-top: 30px;
  }

  .pix-qrcode {
    width: 140px;
    height: 140px;
    background-color: white;
    padding: 10px;
    border-radius: 8px;
    margin: 60px 0 20px;
  }

  .countdown {
    font-weight: 700;
    font-size: 21px;
    margin-top: 20px;
  }

  .hidden-pix-number {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
  }

  .warning-text {
    margin-top: 30px;

    > svg {
      display: inline-block;
      margin-bottom: 10px;
    }
  }

  .cancel-order {
    margin-top: 40px;
  }
}
</style>
